import React from "react";
import { Link } from "react-router-dom";
import { Card } from "@material-ui/core";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import InsertChartIcon from "@material-ui/icons/InsertChart";

// import Progress from "../../progress/Progress";
import styles from "./canada.css";

const provinces = [
  "British Columbia",
  "Alberta",
  "Saskatchewan",
  "Manitoba",
  "Ontario",
  "Quebec",
  "Newfoundland and Labrador",
  "New Brunswick",
  "Nova Scotia",
  "Prince Edward Island",
  "Yukon",
  "Northwest Territories",
];

const Canada = () => {
  return (
    <div className="cardContainer">
      <h1>Stats for Canada</h1>
      {provinces.map((res) => (
        <Card key={res}>
          <CardContent className="MuiCardContent-oot">
            <div>{res}</div>
          </CardContent>
          <CardActions>
            <div className="buttonPanel">
              <Link
                to={"/canadachart/" + res}
                style={{ textDecoration: "none" }}
              >
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  endIcon={<InsertChartIcon />}
                >
                  Chart
                </Button>
              </Link>
            </div>
          </CardActions>
        </Card>
      ))}
    </div>
  );
};

export default Canada;
